var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxMultiple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M9 10.836c0-.604-.265-1.179-.738-1.554C7.539 8.708 6.285 8 4.5 8S1.461 8.708.738 9.282c-.473.375-.738.95-.738 1.554V12h9v-1.164z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 4.5,
    cy: 4.5,
    r: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    fill: "#444",
    cx: 11.5,
    cy: 4.5,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "#444",
    d: "M15.262 9.282C14.539 8.708 13.285 8 11.5 8c-.561 0-1.063.075-1.519.189A3.954 3.954 0 0 1 11 10.836V12h5v-1.164c0-.604-.265-1.179-.738-1.554z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxMultiple);
export default __webpack_public_path__ + "static/media/16px_multiple.a8089c8dec8ed042e0c09fd45ef82cf6.svg";
export { ForwardRef as ReactComponent };